import React from 'react';
import { useNavigate } from 'react-router-dom';
import { trackHomeButtonClick } from '../../utils/analytics';
import SharedButton from '@/global/Button/Button';
import useText from '@/hooks/useText';
import { useAcademicApplication } from '@/hooks/useAcademicApplication';
import { userAppContext } from '@/context/Context';
import { UserContext } from '@/types';
import useScrollWindow from '@/hooks/useScrollWindow';

function HeroContent({ children }: { children?: React.ReactNode }) {
  const navigate = useNavigate();
  const { isMobile, isTablet } = useScrollWindow();
  const isDesktop = !isMobile && !isTablet;

  const eyebrow = useText('home.hero.eyebrow');
  const title = useText('home.hero.title');
  const titleHighlight = useText('home.hero.title_highlight');
  const btnFreeTrial = useText('home.hero.btn_free_trial');
  const btnViewPlans = useText('home.hero.btn_view_plans');
  const btnUpgrade = useText('home.hero.btn_upgrade');

  const { user, isAuthenticated } = userAppContext() as unknown as UserContext;
  const { isCommercial: isCommercialFromHook, loadingStatus } = useAcademicApplication(
    user?.email,
    isAuthenticated,
  );

  const handleStartFreeTrial = () => {
    trackHomeButtonClick('Start free trial', 'home_start_free_trial');
    navigate('/free-trial-apply');
  };

  const handleUpgradePlan = () => {
    trackHomeButtonClick('Upgrade plan', 'home_upgrade_plan');
    navigate('/plans');
  };

  const handleViewPlans = () => {
    trackHomeButtonClick('View plans', 'home_view_plans');
    navigate('/plans');
  };

  return (
    <div className="home-hero-main">
      <div className="home-hero-top">
        <p className="home-hero-eyebrow">{eyebrow}</p>
        <h1 className="home-hero-title mb-4">
          {title}
          <span className="home-hero-highlight">{titleHighlight}</span>
        </h1>
      </div>
      <div className="home-hero-center">
        <div className="home-hero-actions mb-2">
          {!isAuthenticated && (
            <SharedButton
              type="button"
              onClick={handleStartFreeTrial}
              size={isDesktop ? 'md' : 'xs'}
              variant="gradient"
            >
              {btnFreeTrial}
            </SharedButton>
          )}
          {!loadingStatus && !isCommercialFromHook() && isAuthenticated ? (
            <SharedButton
              type="button"
              onClick={handleUpgradePlan}
              size={isDesktop ? 'md' : 'xs'}
              variant="gradient"
            >
              {btnUpgrade}
            </SharedButton>
          ) : (
            <SharedButton
              type="button"
              onClick={handleViewPlans}
              size={isDesktop ? 'md' : 'xs'}
              variant="secondaryOutline"
            >
              {btnViewPlans}
            </SharedButton>
          )}
        </div>
        {children}
      </div>
    </div>
  );
}

export default HeroContent;
